import { Component, inject } from '@angular/core';

@Component({
  selector: 'app-vesel-container',
  standalone: false,
  templateUrl: './vesel-container.component.html',
  styleUrl: './vesel-container.component.scss',
})
export class VeselContainerComponent {}
